<template>
  <div>
    <el-link class="user"
             @click="dialogFormVisible=true"
             type=""
             :underline="false">
      <i class="el-icon-user-solid" style="margin-right: 5px"></i>
      {{user.name }}
    </el-link>
    <el-button type="primary"
               size="mini"
               @click="dialogFormVisible=true"
               icon="el-icon-search">se connecter
    </el-button>
    <el-divider></el-divider>
    <el-dialog class="login--dialog"
               title="Connexion"
               :visible.sync="dialogFormVisible"
               :width="shouldGoResponsive()">
      <UserForm @passwordTry="authTry($event)"></UserForm>
    </el-dialog>
  </div>
</template>

<script>
  import UserForm from './UserForm.vue';

  export default {
    components: {
      UserForm,
    },
    props: {
      user: undefined,
    },
    data() {
      return {
        responsive: false,
        dialogFormVisible: false,
      };
    },
    methods: {
      authTry(password) {
        this.$emit('authTry', {
          name: this.user.name,
          mail: this.user.email,
          password,
          uid: this.user.id,
        });
      },
      // little workaround because for some reasons <el-dialog> tag
      // doesn't give a flying fuck about media-queries or any css rules
      shouldGoResponsive() {
        const width = window.screen.availWidth;
        return width < 800 ? '100%' : '50%';
      },
    },
  };
</script>

<style lang="stylus">
  .user
    justify-content left
    width 200px
    margin-right 10px

</style>
